import(/* webpackMode: "eager" */ "/var/www/nextjs-blue/src/app/not-found.tsx");
